import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetLegalDocumentResponseBody } from '../LegalDocumentsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseLegalDocumentQueryValues = {
  appId: string;
  legalDocumentId: string;
};

export const legalDocumentQueryKeyFactory: IQueryKeyFactory<
  IUseLegalDocumentQueryValues
> = (values) =>
  values && (['legalDocument', values.appId, values.legalDocumentId] as const);

export const useLegalDocumentQuery = (
  values?: IUseLegalDocumentQueryValues,
  options?: UseQueryOptions<IApiGetLegalDocumentResponseBody, ApiError>,
): UseQueryResult<IApiGetLegalDocumentResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: legalDocumentQueryKeyFactory(values),
    queryFn: values
      ? () => api.legalDocuments.get(values.appId, values.legalDocumentId)
      : undefined,
    ...options,
  });
};
